import { DateTime } from 'luxon';

import { DateFilter } from 'src/api';

export const buildCreatedAtMonthBeforeDateFilter = (
  isoDate: string,
): { AND: { createdAt: DateFilter }[] } => {
  const monthBeforeIsoDate = DateTime.fromISO(isoDate, { zone: 'utc' }).minus({ month: 1 }).toISO();

  return {
    AND: [
      {
        createdAt: {
          gt: monthBeforeIsoDate,
        },
      },
      {
        createdAt: {
          lte: isoDate,
        },
      },
    ],
  };
};

export const buildCreatedAtBeforeDateFilter = (isoDate: string): { createdAt: DateFilter } => {
  return {
    createdAt: {
      lte: isoDate,
    },
  };
};
